/**
 * RiderStatus Helpers
 * 라이더 현황 페이지 헬퍼 함수 및 테이블 정의
 */

export interface TableColumn {
    key: string;
    header: string;
}

export const TABLE_COLUMNS: TableColumn[] = [
    { key: 'vpayRegistYn', header: 'Vpay 가입여부' },
    { key: 'supplierName', header: '협력사명' },
    { key: 'name', header: '이름' },
    { key: 'riderTypeName', header: '라이더구분' },
    { key: 'balAmt', header: '보유잔액' },
    { key: 'registNum', header: '주민등록번호' },
    { key: 'phoneNumber', header: '휴대폰번호' },
    { key: 'preAcctYn', header: '선정산' },
    { key: 'joinDate', header: '등록일자' },
    { key: 'contractEndDate', header: '계약종료일자' },
];

export const TOTAL_COLUMN_COUNT = TABLE_COLUMNS.length;

export const getRiderTypeName = (riderType: string | null | undefined): string => {
    if (!riderType || riderType === 'GENERAL') return '일반';
    if (riderType === 'BRANCH_MANAGER') return '지점장';
    if (riderType === '65_YEARS_AGE') return '만65세이상';
    return '일반';
};

export const formatBalance = (amount: number | null | undefined): string => {
    if (amount === null || amount === undefined) return '0원';
    return `${amount.toLocaleString()}원`;
};
